import React from "react";

interface IEmptyBoxBlueIconProps {
  width?: number;
  height?: number;
}

const V2EmptyBoxBlueIcon: React.FC<IEmptyBoxBlueIconProps> = ({
  width = 56,
  height = 56,
}) => {
  return (
    <img
      width={width}
      height={height}
      src="/v2-icon/empty-box-gray.svg"
      alt="empty-box-gray"
    />
  );
};

export default React.memo(V2EmptyBoxBlueIcon);
